import { call, put } from 'redux-saga/effects';
import {
  changeSubscriptionPlanFailure,
  changeSubscriptionPlanSuccess,
} from '../actions';
import { ApiError } from 'store/api/types';
import { ChangeSubscriptionPlanRequestAction } from '../types';
import { checkResponse } from 'store/utils';
import { ChangeSubscriptionPlanResponse, changeSubscriptionPlan } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { push } from 'store/navigation/actions';
import routes from 'routes';
import { fetchMeRequest, logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* changeSubscriptionPlanSaga(
  action: ChangeSubscriptionPlanRequestAction
) {
  try {
    let err: ApiError | null;
    const { subscriptionTypeId, billingCheckout } = action.payload;

    const changeSubscriptionPlanResponse: ChangeSubscriptionPlanResponse =
      yield call(changeSubscriptionPlan, subscriptionTypeId, billingCheckout);

    err = checkResponse(changeSubscriptionPlanResponse?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: changeSubscriptionPlanResponse.responseMessage.message,
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
    yield put(changeSubscriptionPlanSuccess());
    yield put(fetchMeRequest());
    yield put(push(routes.billing.root));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(changeSubscriptionPlanFailure());
  }
}
